"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getListNode = getListNode;
exports.isListParentNode = isListParentNode;
exports.getMatchingValueHandler = exports.overrideInheritedStyles = exports.nodeChangeHandlers = exports.getLineHeightDisplayValue = exports.getFontSelectOptions = exports.normalizeFontStack = void 0;

var _getComputedStyle = require("./getComputedStyle");

var CLEAN_FONT_STACK_QUOTES_REGEXP = /['"]/g;
var CLEAN_FONT_STACK_COMMAS_REGEXP = /(, )/g;

var normalizeFontStack = function normalizeFontStack(fontStack) {
  return fontStack.replace(CLEAN_FONT_STACK_QUOTES_REGEXP, '').replace(CLEAN_FONT_STACK_COMMAS_REGEXP, ',').toLowerCase();
};

exports.normalizeFontStack = normalizeFontStack;

var getFontSelectOptions = function getFontSelectOptions(fonts) {
  if (!fonts) {
    return [];
  }

  return Object.keys(fonts).sort().map(function (font) {
    return {
      text: font,
      value: fonts[font]
    };
  });
};

exports.getFontSelectOptions = getFontSelectOptions;

var createNodeChangeHandler = function createNodeChangeHandler(handlerFunc) {
  var inherits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (e) {
    var element = e.element,
        target = e.target,
        parents = e.parents;
    var win = target.getWin();
    var computedStyle = (0, _getComputedStyle.maybeGetComputedStyle)(win, element) || {};
    var elementHasStyle = handlerFunc(computedStyle);

    if (!elementHasStyle && inherits) {
      //some styles will inherit an active style from the parent no matter what (underline)
      //check all the parents to see if they have the style even though the child doesn't
      return !!parents.find(function (p) {
        computedStyle = (0, _getComputedStyle.maybeGetComputedStyle)(win, p) || {};
        return handlerFunc(computedStyle);
      });
    }

    return elementHasStyle;
  };
};

var getLineHeightDisplayValue = function getLineHeightDisplayValue(win, element) {
  var computedStyle = (0, _getComputedStyle.maybeGetComputedStyle)(win, element);

  if (!computedStyle) {
    return null;
  }

  var computedLineHeight = computedStyle['line-height'];
  var computedFontSize = computedStyle['font-size'];
  var parsedLineHeight = parseFloat(computedLineHeight);
  var parsedFontSize = parseFloat(computedFontSize);

  if (!isNaN(parsedLineHeight) && !isNaN(parsedFontSize)) {
    return parsedLineHeight / parsedFontSize;
  }

  return null;
};

exports.getLineHeightDisplayValue = getLineHeightDisplayValue;
var nodeChangeHandlers = {
  bold: createNodeChangeHandler(function (computedStyle) {
    if (computedStyle.fontWeight === 'bold' || computedStyle.fontWeight > 400) {
      return true;
    }

    return false;
  }),
  underline: createNodeChangeHandler(function (computedStyle) {
    return computedStyle.textDecoration.includes('underline');
  }, true),
  italic: createNodeChangeHandler(function (computedStyle) {
    return computedStyle.fontStyle.includes('italic');
  })
};
exports.nodeChangeHandlers = nodeChangeHandlers;
var overrideInheritedStyles = {
  bold: {
    on: 'bold',
    off: 'normal',
    affectedStyles: ['font-weight'],
    inlineElements: ['b', 'strong'],
    tinyMCECommand: 'bold'
  },
  italic: {
    on: 'italic',
    off: 'normal',
    affectedStyles: ['font-style'],
    inlineElements: ['i', 'em'],
    tinyMCECommand: 'italic'
  },
  underline: {
    on: 'underline',
    off: 'none',
    affectedStyles: ['text-decoration'],
    inlineElements: ['u'],
    tinyMCECommand: 'underline'
  }
};
exports.overrideInheritedStyles = overrideInheritedStyles;

var getMatchingValueHandler = function getMatchingValueHandler(editor, format, values) {
  return function (nodeChangeEvent) {
    var parents = nodeChangeEvent.parents,
        element = nodeChangeEvent.element;
    var formatter = editor.formatter;
    var newControlValue = false;

    var _loop = function _loop(i) {
      var matchingItem = values.find(function (item) {
        return formatter.matchNode(parents[i], format, {
          value: item.value
        });
      });

      if (matchingItem) {
        newControlValue = matchingItem.value;
        return "break";
      }
    };

    for (var i = 0; i < parents.length; i++) {
      var _ret = _loop(i);

      if (_ret === "break") break;
    }

    if (!newControlValue) {
      var maybeLineHeightDisplayValue = getLineHeightDisplayValue(editor.getWin(), element);
      var matched = values.find(function (item) {
        return item.value === maybeLineHeightDisplayValue;
      });
      newControlValue = matched ? matched.value : null;
    }

    return newControlValue;
  };
};

exports.getMatchingValueHandler = getMatchingValueHandler;

function getListNode(editor, selectedNode) {
  if (!selectedNode) return null;
  return editor.dom.getParent(selectedNode, 'li', editor.getBody());
}

function isListParentNode(selectedNode) {
  if (!selectedNode) return null;
  return ['OL', 'UL'].includes(selectedNode.nodeName);
}